import { mediaHttp } from '@/lib/api/http-client';
import { parseResponse } from '@/lib/api/parse-response';
import { mediaGuidelineSchema } from './schemas';
import type {
  CreateMediaGuidelineInput,
  GuidelineStatus,
  MediaGuideline,
  UpdateGuidelineDraftInput,
} from '../model/types';

export async function createMediaGuideline(
  input: CreateMediaGuidelineInput,
): Promise<MediaGuideline> {
  const res = await mediaHttp.post({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/media-guidelines',
    body: input,
  });

  return parseResponse(mediaGuidelineSchema, res);
}

export async function updateGuidelineDraft(
  id: string,
  input: UpdateGuidelineDraftInput,
): Promise<MediaGuideline> {
  const res = await mediaHttp.put({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/media-guidelines/{id}/draft',
    path: { id },
    body: input,
  });

  return parseResponse(mediaGuidelineSchema, res);
}

/** Opens a new draft copied from the published version, so history stays a chain. */
export async function startGuidelineDraft(id: string): Promise<MediaGuideline> {
  const res = await mediaHttp.post({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/media-guidelines/{id}/versions',
    path: { id },
    body: {},
  });

  return parseResponse(mediaGuidelineSchema, res);
}

export async function publishGuideline(id: string, reason: string): Promise<MediaGuideline> {
  const res = await mediaHttp.post({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/media-guidelines/{id}/publish',
    path: { id },
    body: { reason },
  });

  return parseResponse(mediaGuidelineSchema, res);
}

export async function retireGuideline(
  id: string,
  status: Exclude<GuidelineStatus, 'active'>,
  reason: string,
): Promise<MediaGuideline> {
  const res = await mediaHttp.post({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/media-guidelines/{id}/retire',
    path: { id },
    body: { status, reason },
  });

  return parseResponse(mediaGuidelineSchema, res);
}

export async function deleteMediaGuideline(id: string): Promise<void> {
  await mediaHttp.delete({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/media-guidelines/{id}',
    path: { id },
  });
}
